import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  /** Кастомный текст вместо дефолтного «Нет данных» */
  children?: ReactNode;
};

/**
 * Плейсхолдер пустого состояния для карточек дашборда.
 * По умолчанию выводит переведённое «Нет данных».
 */
export const EmptyState: FC<Props> = ({ children }) => {
  const { t } = useTranslation('qualityDashboard');
  return <div className="text-muted-foreground text-sm">{children ?? t('noData')}</div>;
};
